import { useState, useEffect } from 'react';
import { useAuthenticatedApi } from './useAuthenticatedApi';

export interface Commit {
  id: string;
  message: string;
  author: string;
  author_email: string;
  date: string;
}

interface UseWorkspaceCommitsResult {
  commits: Commit[];
  loading: boolean;
  error: Error | null;
  refetch: () => void;
}

export const useWorkspaceCommits = (
  workspaceId: string | undefined, 
  limit: number = 20
): UseWorkspaceCommitsResult => {
  const authenticatedApi = useAuthenticatedApi();
  const [commits, setCommits] = useState<Commit[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchCommits = async () => {
    if (!workspaceId) return;

    setLoading(true);
    setError(null);
    
    try {
      const data = await authenticatedApi.get<{ commits: Commit[] }>(
        `/workspaces/${workspaceId}/commits?limit=${limit}`
      );
      setCommits(data.commits || []);
    } catch (err) {
      console.error('Error fetching commits:', err);
      setError(err as Error);
      setCommits([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCommits();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaceId, limit]);

  return { commits, loading, error, refetch: fetchCommits };
}; 